<template>
  <div class="header-info pointer">
    <div class="left-wrap">
      <div class="name">{{ sheet.data.name }}</div>
      <div class="field">{{ mainField.name }}</div>
    </div>
    <div class="right-wrap">
      <el-tooltip
        class="item"
        effect="dark"
        placement="bottom"
        v-for="(btn, index) in btnArray.slice(0, 3)"
        :key="index"
        :content="btn.desc"
        :disabled="!btn.hasOwnProperty('desc') || _.isEmpty(btn.desc)"
      >
        <base-button
          size="normal"
          :style="
            btn.bgColor === '#fff'
              ? 'background:' + btn.bgColor
              : 'border:none;background:' + btn.bgColor
          "
        >
          <svg-icon :style="'color:' + btn.textColor" :icon-class="btn.icon"></svg-icon>
          <span :style="'color:' + btn.textColor">
            {{ btn.label }}
          </span>
        </base-button>
      </el-tooltip>
      <dropdown-menu
        style="margin-left: 10px"
        v-if="btnArray.length > 3"
        :menu-list="btnArray.slice(3)"
        placement="bottom-end"
        trigger="hover"
        from="detailDialog"
      >
        <base-button size="normal" style="width: 32px; padding: 0">
          <i class="el-icon-more"></i>
        </base-button>
      </dropdown-menu>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
export default {
  name: "header-info",
  components: { BaseButton, DropdownMenu },
  props: {
    sheet: Object,
    mainField: Object,
    btnArray: Array
  },
  methods: {
    init(btns) {
      //
    }
  }
}
</script>

<style lang="scss" scoped>
.header-info {
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #fff;
  padding: 12px 16px;
  box-sizing: border-box;
  border: 1px solid #dee1e6;
  border-radius: 4px;
  &:hover {
    border: 1px dashed #ff8000;
  }
  .left-wrap {
    margin-right: auto;
    .name {
      font-size: 17px;
    }
    .field {
      font-size: 20px;
      font-weight: bold;
    }
  }
  .right-wrap {
    display: flex;
  }
  .icon-more {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    width: 28px;
    height: 28px;
    background: #50a5ff;
    border-radius: 3px;
    color: #fff;
    cursor: pointer;
    &:hover {
      background: #66b1ff;
      border-color: #66b1ff;
    }
  }
}
</style>
